module.exports = __webpack_public_path__ + "static/img/b5.5c2c247.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/b5.jpg
// module id = h8xE
// module chunks = 1